import React from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import styles from "./styles/size-warning.css.js";
import withStyles from "components/with-styles";
import FormHelperText from "@material-ui/core/FormHelperText";
import Icon from "components/icon";

const SizeWarning = ({ classes, intl, size }) => (
  <div className={classes.warning}>
    <Icon className={classes.icon} name="warning" />
    <FormHelperText className={classes.message}>
      {intl.formatMessage({ id: "app.form.size.biggerThanAsset" }, size)}
    </FormHelperText>
  </div>
);

SizeWarning.propTypes = {
  /**
   * Object with the size of the image, in px
   **/
  size: PropTypes.object,
};

export default withStyles(styles)(injectIntl(SizeWarning));
